<template>
    <div>
        <div class="top">
            <van-nav-bar title="奖励政策" left-text="返回" left-arrow @click-left="onClickLeft"/>
        </div>
        <div class="content">
            <p v-html="reward"></p>
        </div>
    </div>
</template>

<script>
  import { httpPost, httpGet } from "../../../../axios/index";

    export default {
        name: "schoolInfo",
        data() {
            return {
                reward:"",
            }
        },
        methods: {
            onClickLeft() {
                this.$router.go(-1);
            },
            selectMenu(item){
                this.currentId = item.id
            },
            loadInfo() {
                httpPost(  
                    "/saas/lists",
                    {schoolid: this.$route.query.id, mark: 12}
                )
                    .then(response => {
                        if (response.code === 1) {
                            this.reward = response.data;
                        }
                    })
            }
        },
        mounted() {
            this.loadInfo();
        }
    }
</script>

<style scoped>
.content{
    line-height: 2rem;
    font-size: 0.9rem;
    padding: 0.2rem 0.4rem;
}
</style>